import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, merge, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NetworkService {
  public httpClient: HttpClient;
  private online$ = new BehaviorSubject<boolean>(navigator.onLine);

  constructor(private http: HttpClient) {
    this.httpClient = http;
    merge(
      fromEvent(window, 'online').pipe(map(() => true)),
      fromEvent(window, 'offline').pipe(map(() => false))
    ).subscribe(this.online$);
  }

  isOnline(): Observable<boolean> {
    return this.online$.asObservable();
  }


  //TODO: sauvegarder countries en BdD locale
  countries: { [key: string]: string }[] = []
  getCountries(): Promise<{ [key: string]: string }[]> {
    return new Promise((resolve) => {
      if (this.isOnline()) {
        const headers = {};
        this.http.get(environment.API_URL + 'userProfile/ws_public/GetProfilBlank/', { headers }).subscribe(
          (response: { [key: string]: any }) => {
            this.countries = response['countries'] || [];
            resolve(this.countries);
          },
          () => resolve(this.countries)
        );
      } else {
        resolve(this.countries);
      }
    });
  }
}
